import { render, staticRenderFns } from "./positioning.vue?vue&type=template&id=6b1a57eb&scoped=true&"
import script from "./positioning.vue?vue&type=script&lang=js&"
export * from "./positioning.vue?vue&type=script&lang=js&"
import style0 from "./positioning.vue?vue&type=style&index=0&id=6b1a57eb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b1a57eb",
  null
  
)

export default component.exports